export const SET_POPUPS = 'SET_POPUPS';